// *******************************************************************************
// Open Gallery Modal
// *******************************************************************************

attachEvent('.image-gallery__image', 'click', (ev) => {
  const parent = ev.target.closest('.image-gallery');
  const galleryModal = parent.querySelector('.gallery-modal');
  galleryModal.classList.add('is-open-gallery-modal');
});
